// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_FEATURE_ON_MARKET_FROM = "Modelov\u00fd rok";
export const STROLLER_FEATURE_PRICE_RANGE_from_to = "%(from)s K\u010d - %(to)s K\u010d";
export const STROLLER_FEATURE_WEIGHT_IN_KG = "Hmotnost (v kg)";
export const STROLLER_UNFOLDED_DIMENSIONS_IN_CM_WIDTH = "\u0160\u00ed\u0159ka ko\u010d\u00e1rku";
